import { useQuery } from '@tanstack/react-query';
import type { OrganizationApiKey } from '../types/Organization';

export default function useFetchOrganizationApiKey() {
  return useQuery({
    queryKey: ['organization_api_key'],
    queryFn: async () => {
      const response = await fetch('/agent/api/organization/api_key');
      if (!response.ok) {
        if (response.status === 404) {
          return null;
        }
        throw new Error('Failed to fetch API key');
      }
      const data: OrganizationApiKey = await response.json();
      return data;
    },
  });
}
